export default "__VITE_ASSET__Cbh2Qc8W__"